import { Components, Theme } from '@mui/material/styles';

import { MuiAccordionSummary } from './componentsOverrides/AccordionSummary';
import { MuiAutocomplete } from './componentsOverrides/Autocomplete';
import { MuiButton } from './componentsOverrides/Button';
import { MuiCssBaseline } from './componentsOverrides/CssBaseline';
import { MuiInputLabel } from './componentsOverrides/InputLabel';
import { MuiOutlinedInput } from './componentsOverrides/OutlinedInput';
import { MuiPaper } from './componentsOverrides/Paper';
import { MuiIconButton } from './componentsOverrides/IconButton';
import { MuiSwitch } from './componentsOverrides/Switch';
import { MuiBreadcrumbs } from './componentsOverrides/Breadcrumbs';
import { MuiChip } from './componentsOverrides/Chip';
import { MuiAppBar } from './componentsOverrides/AppBar';
import { MuiToolbar } from './componentsOverrides/MuiToolbar';
import { MuiInput } from './componentsOverrides/Input';
import { MuiPopover } from './componentsOverrides/Popover';
import { MuiTypography } from './componentsOverrides/Typography';
import { MuiSelect } from './componentsOverrides/Select';
import { MuiMenuItem } from './componentsOverrides/MenuItem';

export const components: Components<Theme> = {
  MuiAccordionSummary,
  MuiAutocomplete,
  MuiButton,
  MuiCssBaseline,
  MuiInputLabel,
  MuiOutlinedInput,
  MuiPaper,
  MuiIconButton,
  MuiSwitch,
  MuiBreadcrumbs,
  MuiChip,
  MuiAppBar,
  MuiToolbar,
  MuiInput,
  MuiTypography,
  MuiPopover,
  MuiSelect,
  MuiMenuItem,
};
